import React from "react";

const PrivacyPolicy = () => (
  <div className="max-w-3xl mx-auto px-4 py-8 text-gray-900 dark:text-gray-100">
    <h1 className="text-3xl font-bold mb-6 text-center">Privacy Policy</h1>
    <p className="mb-4">IncogJson values your privacy. All data processing (validation, conversion, formatting) happens locally in your browser. We do not store, track, or transmit your data to any server. No cookies, analytics, or third-party tracking scripts are used on this site.</p>
    <ul className="list-disc list-inside mb-4">
      <li>No data is uploaded or saved.</li>
      <li>No user tracking or analytics.</li>
      <li>No cookies or persistent identifiers.</li>
      <li>Feedback form attachments are only used for support and are not shared.</li>
    </ul>
    <p>If you have questions about privacy, please use the feedback form on the About page.</p>
  </div>
);

export default PrivacyPolicy;
